import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getSalaryDetails,
  clearError,
} from "../../../../redux/Slices/authSlice";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const SalaryDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("global");
  const isRTL = i18n.language === "ar";
  const { salaryDetails, isLoading, error } = useSelector(state => state.auth);
  const textAlign = isRTL ? "right" : "left";
  const dir = isRTL ? "rtl" : "ltr";
  const lastErrorRef = useRef({ message: null, time: 0 });

  useEffect(() => {
    if (id) {
      dispatch(getSalaryDetails(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (error) {
      const now = Date.now();
      const last = lastErrorRef.current;
      if (!last.message || last.message !== error || now - last.time > 2000) {
        toast.error(error, { rtl: isRTL });
        lastErrorRef.current = { message: error, time: now };
      }
      setTimeout(() => dispatch(clearError()), 3000);
    }
  }, [error, dispatch, isRTL]);

  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US");
  };

  const formatCurrency = amount => {
    return (
      parseFloat(amount).toLocaleString("en-US") + " " + t("salaries.currency")
    );
  };

  if (isLoading) {
    return (
      <div
        style={{
          padding: "30px",
          backgroundColor: "#14263b",
          minHeight: "calc(100vh - 80px)",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>{t("salaries.details.loading")}</div>
      </div>
    );
  }

  if (!salaryDetails) {
    return (
      <div
        style={{
          padding: "30px",
          backgroundColor: "#14263b",
          minHeight: "calc(100vh - 80px)",
          color: "white",
          textAlign: "center",
        }}
      >
        <div>{t("salaries.details.noData")}</div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#14263b",
        minHeight: "calc(100vh - 80px)",
        color: "white",
        direction: dir,
      }}
    >
      <div style={{ marginBottom: "30px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            marginBottom: "20px",
          }}
        >
          <button
            onClick={() => navigate("/salaries")}
            style={{
              backgroundColor: "#666",
              color: "white",
              border: "none",
              padding: "10px",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexDirection: isRTL ? "row" : "row-reverse",
            }}
          >
            <FaArrowLeft />
            {t("salaries.details.back")}
          </button>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "white",
              margin: 0,
              textAlign,
            }}
          >
            {t("salaries.details.title")}
          </h1>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#1b3350",
          borderRadius: "12px",
          padding: "20px",
          border: "1px solid #333",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
          }}
        >
          <div>
            <h3
              style={{
                color: "white",
                marginBottom: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                textAlign,
              }}
            >
              {t("salaries.details.sections.baseSalary")}
            </h3>
            <div
              style={{
                backgroundColor: "#1a1f2e",
                padding: "15px",
                borderRadius: "8px",
                border: "1px solid #333",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {formatCurrency(salaryDetails.base_salary)}
              </div>
            </div>
          </div>

          {/***********تاريخ السريان *************/}
          <div>
            <h3
              style={{
                color: "white",
                marginBottom: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                textAlign,
              }}
            >
              {t("salaries.details.sections.effectiveDate")}
            </h3>
            <div
              style={{
                backgroundColor: "#1a1f2e",
                padding: "15px",
                borderRadius: "8px",
                border: "1px solid #333",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {formatDate(salaryDetails.effective_date)}
              </div>
            </div>
          </div>

          {/********** Salaries  allowances ***************/}
          <div>
            <h3
              style={{
                color: "white",
                marginBottom: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                textAlign,
              }}
            >
              {t("salaries.details.sections.allowances")}
            </h3>
            <div
              style={{
                backgroundColor: "#1a1f2e",
                padding: "15px",
                borderRadius: "8px",
                border: "1px solid #333",
              }}
            >
              {salaryDetails.allowances?.housing && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "8px",
                    padding: "8px",
                    backgroundColor: "#AC2000",
                    borderRadius: "6px",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ color: "white", fontWeight: "bold" }}>
                    {t("salaries.details.labels.housing")}
                  </span>
                  <span style={{ color: "white" }}>
                    {formatCurrency(salaryDetails.allowances.housing)}
                  </span>
                </div>
              )}
              {salaryDetails.allowances?.transportation && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "8px",
                    padding: "8px",
                    backgroundColor: "#AC2000",
                    borderRadius: "6px",
                    fontSize: "14px",
                    flexDirection: isRTL ? "row" : "row-reverse",
                  }}
                >
                  <span style={{ color: "white", fontWeight: "bold" }}>
                    {t("salaries.details.labels.transportation")}
                  </span>
                  <span style={{ color: "white" }}>
                    {formatCurrency(salaryDetails.allowances.transportation)}
                  </span>
                </div>
              )}
              {!salaryDetails.allowances?.housing &&
                !salaryDetails.allowances?.transportation && (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#666",
                      fontStyle: "italic",
                      fontSize: "14px",
                    }}
                  >
                    {t("salaries.details.labels.noAllowances")}
                  </div>
                )}
            </div>
          </div>

          {/**********الخصومات*******/}
          <div>
            <h3
              style={{
                color: "white",
                marginBottom: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                textAlign,
              }}
            >
              {t("salaries.details.sections.deductions")}
            </h3>
            <div
              style={{
                backgroundColor: "#1a1f2e",
                padding: "15px",
                borderRadius: "8px",
                border: "1px solid #333",
              }}
            >
              {salaryDetails.deductions?.social_insurance && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "8px",
                    padding: "8px",
                    backgroundColor: "rgba(220, 53, 69, 0.1)",
                    borderRadius: "6px",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ color: "#dc3545", fontWeight: "bold" }}>
                    {t("salaries.details.labels.socialInsurance")}
                  </span>
                  <span>
                    {formatCurrency(salaryDetails.deductions.social_insurance)}
                  </span>
                </div>
              )}
              {!salaryDetails.deductions?.social_insurance && (
                <div
                  style={{
                    textAlign: "center",
                    color: "#666",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  {t("salaries.details.labels.noDeductions")}
                </div>
              )}
            </div>
          </div>
        </div>

        {/************ ملخص الرواتب ***********/}
        <div
          style={{
            marginTop: "20px",
            padding: "15px",
            backgroundColor: "#1a1f2e",
            borderRadius: "8px",
            border: "1px solid #333",
          }}
        >
          <h3
            style={{
              color: "white",
              marginBottom: "12px",
              fontSize: "16px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {t("salaries.details.sections.summary")}
          </h3>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div
                style={{ color: "#ccc", fontSize: "12px", marginBottom: "4px" }}
              >
                {t("salaries.details.labels.baseSalaryLabel")}
              </div>
              <div
                style={{ color: "white", fontSize: "16px", fontWeight: "bold" }}
              >
                {formatCurrency(salaryDetails.base_salary)}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div
                style={{ color: "#ccc", fontSize: "12px", marginBottom: "4px" }}
              >
                {t("salaries.details.labels.totalAllowances")}
              </div>
              <div
                style={{ color: "white", fontSize: "16px", fontWeight: "bold" }}
              >
                {formatCurrency(
                  (salaryDetails.allowances?.housing || 0) +
                    (salaryDetails.allowances?.transportation || 0),
                )}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div
                style={{ color: "#ccc", fontSize: "12px", marginBottom: "4px" }}
              >
                {t("salaries.details.labels.totalDeductions")}
              </div>
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              >
                {formatCurrency(
                  salaryDetails.deductions?.social_insurance || 0,
                )}
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div
                style={{ color: "#ccc", fontSize: "12px", marginBottom: "4px" }}
              >
                {t("salaries.details.labels.netSalary")}
              </div>
              <div
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                  padding: "8px 16px",
                  backgroundColor: "#AC2000",
                  borderRadius: "8px",
                  border: "2px solid #AC2000",
                }}
              >
                {formatCurrency(
                  parseFloat(salaryDetails.base_salary) +
                    (salaryDetails.allowances?.housing || 0) +
                    (salaryDetails.allowances?.transportation || 0) -
                    (salaryDetails.deductions?.social_insurance || 0),
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalaryDetails;
